
export default [
    {
        path: '/dataList/inventoryInquire',
        component: resolve => require(['../page.vue'], resolve),
        meta: {
            title: '库存查询',
            keepAlive: false
        }
  },
  {
    path: '/dataList/inventoryInquire/dayReport',
    component: resolve => require(['../dayReport.vue'], resolve),
    meta: {
        title: '库存报表查询',
        keepAlive: false
    }
},
];
  